"use client";

import type { FC, Ref } from "react";
import {
  AnalysisObservations,
  type AnalysisObservationsProps,
} from "@huub-web/shared";

export interface AnalysisObservationsTemplateProps {
  categories: AnalysisObservationsProps["categories"];
}

/**
 * @deprecated
 */
export const AnalysisObservationsTemplate: FC<
  AnalysisObservationsTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ categories, ref }) => (
  <AnalysisObservations ref={ref} categories={categories} container="default" />
);
